import VSLFormField from "./VSLFormField";
import LangUtils from '@/utils/LangUtils'

export default class VSLSingleSelectFormField extends VSLFormField {

    constructor(id, field, locale) {
        super(id, field, locale);

        this.options = field.possibleValues.map(possible => {
          return {
            display: LangUtils.valueForLanguage(possible.displayValue, locale),
            value: possible.value,
          }
        })
    }
}
